import React from "react";

import ModalOverlay from "components/UI/ModalOverlay";
import moment from "moment";

const UserModal = props => {
  const style = {
    modalBody: {
      position: "relative",
      width: "400px",
      padding: "25px",
      paddingTop: "100px",
      display: "flex",
      justifyContent: "center",
      flexDirection: "column",
      alignItems: "center"
    },
    profileImage: {
      position: "absolute",
      top: "-75px",
      borderRadius: "100%",
      width: "150px",
      height: "150px"
    },
    name: {
      fontSize: "30px",
      color: "#00b4d2",
      letterSpacing: "5px",
      margin: "0px 0px 0px 0px"
    },
    textNormal: {
      fontSize: "20px",
      color: "#444445",
      margin: "0px",
      letterSpacing: "5px"
    }
  };
  return (
    <ModalOverlay noTitle bodyStyle={style.modalBody} close={props.close}>
      <img
        src={
          props.user.photo_url
            ? props.user.photo_url
            : "https://via.placeholder.com/200x200"
        }
        style={style.profileImage}
        alt="User"
      />
      <p style={style.name}>{props.user.name}</p>
      <p style={style.textNormal}>
        {`${moment().diff(moment(props.user.checkin_time), "minutes")} mins`}
      </p>
      <br />
      <p style={style.textNormal}>{props.user.email}</p>
      <p style={style.textNormal}>{props.user.phone}</p>
      <p style={style.textNormal}>{String(props.user.address).split(",")[1]}</p>
    </ModalOverlay>
  );
};

export default UserModal;
